import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'connectionLocationFormat'
})
export class ConnectionLocationFormatPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const arr = value.split(' ').map((x, i) => {
      if (x.includes(',')) {
        return x.slice(0, x.length - 1);
      }
      return x;
    });
    return arr.slice(2, arr.length).join(' ') + ',' + arr.slice(0, 2).join(' ');
  }
}
